export default __webpack_public_path__ + "static/media/wFPortfolio.e41bec93.mp4";